
import React from 'react';
import { useSidebar } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";
import { Menu, ChevronLeft } from "lucide-react";

export const SidebarToggleButton = () => {
  const { state, toggleSidebar } = useSidebar();
  
  return (
    <div 
      onClick={toggleSidebar}
      className="flex items-center justify-center h-7 w-7 hover:bg-blue-100 rounded-md cursor-pointer transition-colors"
      title={state === "collapsed" ? "Expandir menu" : "Recolher menu"}
    >
      {state === "collapsed" ? (
        <Menu className="h-5 w-5 text-blue-dark" />
      ) : (
        <ChevronLeft className="h-5 w-5 text-blue-dark" />
      )}
      <span className="sr-only">Toggle Sidebar</span>
    </div>
  );
};

export const SidebarCollapseIndicator = () => {
  const { state, toggleSidebar, isMobile } = useSidebar();
  
  // Don't show this indicator on mobile
  if (isMobile || state !== "collapsed") return null;
  
  return (
    <div 
      className="fixed left-2 top-6 z-50 bg-white p-2 rounded-md shadow-md cursor-pointer hover:bg-gray-100 transition-all md:flex items-center justify-center hidden"
      onClick={toggleSidebar}
      title="Expandir menu"
    >
      <Menu className="h-5 w-5 text-blue-dark" />
    </div>
  );
};

// Novo componente para dispositivos móveis
export const MobileSidebarContent = ({children}: {children: React.ReactNode}) => {
  const { openMobile, setOpenMobile } = useSidebar();
  
  return (
    <>
      <div 
        className={cn(
          "fixed inset-0 bg-black/50 z-50 md:hidden transition-opacity",
          openMobile ? "opacity-100" : "opacity-0 pointer-events-none"
        )}
        onClick={() => setOpenMobile(false)}
      />
      <div 
        className={cn(
          "fixed inset-y-0 left-0 w-[75vw] max-w-xs bg-white z-50 shadow-xl transition-transform md:hidden pt-14",
          openMobile ? "translate-x-0" : "-translate-x-full"
        )}
      >
        {children}
      </div>
    </>
  );
};
